import {motion} from 'framer-motion';
import './characters-page.css';
import './character-grid-compact.css';

export const characters=[
  {
    id:'kuremio',
    number:'01',
    kanji:'紅澪',
    roman:'KUREMIO',
    roleZh:'味之連結者',
    roleEn:'CONNECTOR OF TASTES',
    divisionZh:'向付組 · 攻擊',
    divisionEn:'MUKOZUKE · ATTACK',
    bloodZh:'食材之靈（鮭）',
    bloodEn:'MATERIAL SPIRIT · SALMON',
    tekuse:'燃 · MOE',
    accent:'#bd3026',
    image:'https://media-manager-c.questera.ai/greta-media/048a294ccd6718892c549bd7b643fcf120d7d84b38289b7b4b78889b4f78a748e8c921a45f072a6a0302366ee1557436/images/aW1hZ2UvanBlZw==/024766f5fd25eb20670673974c6ba2a9.jpg',
    quoteZh:'「那些被封緘於食材之中、未能出口的話語……我僅是為傾聽而來。」',
    quoteEn:'“I came only to listen to the words sealed within each ingredient.”',
    profileZh:'沉靜內斂，偶爾顯得一種不受外界干擾的專注。她能感知食材內部殘留的情緒碎片，並以料理在記憶與現實之間架起橋樑。',
    profileEn:'Quiet and deeply focused,she senses emotional fragments left inside ingredients and uses cuisine to bridge memory and the present.',
    storyZh:'紅澪隸屬向付組。當旬之淵因客人的未竟心事而亮起，她會循著鮭之血脈逆流下潛。她不追逐最稀有的旬味，只尋找那份能替客人說出未言之語的鮮。',
    storyEn:'Kuremio serves in the Mukozuke Division. When the Abyss responds to an unfinished feeling,she follows the salmon bloodline upstream,seeking the freshness capable of speaking for the guest.',
    traitsZh:[
      '傾聽未竟情感',
      '以鮭之血脈逆流尋鮮',
      '燃起客人未能言明的心'
    ],
    traitsEn:[
      'Listens to unfinished feelings',
      'Follows the salmon bloodline upstream',
      'Ignites the heart left unspoken'
    ]
  },
  {
    id:'tamasumi',
    number:'02',
    kanji:'玉澄',
    roman:'TAMASUMI',
    roleZh:'守火之人',
    roleEn:'KEEPER OF FIRE',
    divisionZh:'焼物組 · 防禦',
    divisionEn:'YAKIMONO · DEFENSE',
    bloodZh:'守護之靈（玉子）',
    bloodEn:'GUARDIAN SPIRIT · TAMAGO',
    tekuse:'安 · AN',
    accent:'#b3912f',
    image:'https://media-manager-c.questera.ai/greta-media/048a294ccd6718892c549bd7b643fcf120d7d84b38289b7b4b78889b4f78a748e8c921a45f072a6a0302366ee1557436/images/aW1hZ2UvanBlZw==/75d3787f081804f7eabe0898b072a4b3.jpg',
    quoteZh:'「火不必猛烈。只要在需要它的人抵達以前，始終沒有熄滅。」',
    quoteEn:'“Fire need not rage. It only needs to remain until the one who needs it arrives.”',
    profileZh:'沉著可靠，以不急不躁的火候維持席間平衡。她的力量不是阻止變化，而是在變化之中保存最適切的溫度與安定。',
    profileEn:'Calm and dependable,she keeps every course in balance with an unhurried flame,preserving warmth and stability through change.',
    storyZh:'玉澄隸屬焼物組，是下淵隊伍的守火者。愈接近深層，水壓與遺失的記憶愈容易動搖人心；她以玉子血脈展開安定的圓環，讓同伴始終保有回程的溫度。',
    storyEn:'Tamasumi serves in the Yakimono Division as keeper of the descent flame. As pressure and lost memories intensify,her tamago bloodline forms a circle of calm that preserves the way home.',
    traitsZh:[
      '守護不滅之火',
      '以玉子血脈包覆旬味',
      '讓席間萬物回到安定'
    ],
    traitsEn:[
      'Guards the undying flame',
      'Enfolds flavor through the tamago bloodline',
      'Returns the table to stillness'
    ]
  }
];

function CharacterCard({character,english,onNavigate}){
  const path=`${english?'/en':''}/characters/${character.id}/`;

  return(
    <motion.a
      className="character-card"
      href={path}
      style={{'--character-accent':character.accent}}
      onClick={(event)=>{
        event.preventDefault();
        onNavigate(path);
      }}
      initial={{opacity:0,y:24}}
      whileInView={{opacity:1,y:0}}
      whileHover={{y:-6}}
      viewport={{once:true,amount:.2}}
      transition={{duration:.5}}
      aria-label={`${english?'View character profile':'查看人物檔案'}：${character.kanji}`}
    >
      <div className="character-card__visual">
        <span className="character-card__number">{character.number}</span>
        <span className="character-card__vertical">{character.roman}</span>
        <img
          src={character.image}
          alt={`${character.kanji} ${character.roman}`}
        />
        <b aria-hidden="true">{character.kanji}</b>
      </div>
      <div className="character-card__caption">
        <small>
          {english?character.divisionEn:character.divisionZh}
        </small>
        <h2>{character.kanji}</h2>
        <p>{english?character.roleEn:character.roleZh}</p>
        <span>{english?'VIEW PROFILE':'查看檔案'} ↗</span>
      </div>
    </motion.a>
  );
}

function CharacterIndex({english,onNavigate}){
  return(
    <section className="characters-page">
      <header className="characters-page__intro">
        <span>CHARACTER ARCHIVE · 人物檔案</span>
        <h1>
          {english?'Itamae of Shunshin Ryotei':'旬心料亭人物名鑑'}
        </h1>
        <p>
          {english
            ?'Select a character to explore their bloodline,Kuse and story.'
            :'選擇人物，閱讀其血脈、手癖、所屬組別與專屬故事。'}
        </p>
      </header>
      <div className="character-card-grid">
        {characters.map((character)=>(
          <CharacterCard
            character={character}
            english={english}
            onNavigate={onNavigate}
            key={character.id}
          />
        ))}
      </div>
    </section>
  );
}

function CharacterNavigation({
  character,
  english,
  onNavigate
}){
  const currentIndex=characters.findIndex(
    (item)=>item.id===character.id
  );
  const previous=characters[currentIndex-1];
  const next=characters[currentIndex+1];
  const destination=next||previous;

  if(!destination){
    return null;
  }

  const direction=next?'next':'previous';
  const path=`${english?'/en':''}/characters/${destination.id}/`;
  const label=direction==='next'
    ? english?'NEXT CHARACTER':'下一位人物'
    : english?'PREVIOUS CHARACTER':'上一位人物';
  const arrow=direction==='next'?'→':'←';

  return(
    <a
      className={`character-detail__next character-detail__next--${direction}`}
      href={path}
      onClick={(event)=>{
        event.preventDefault();
        onNavigate(path);
      }}
    >
      <small>{label}</small>
      <strong>{destination.kanji}</strong>
      <span>
        {arrow} {destination.roman}
      </span>
    </a>
  );
}

function CharacterDetail({character,english,onNavigate}){
  const traits=english?character.traitsEn:character.traitsZh;
  const indexPath=english?'/en/characters/':'/characters/';

  return(
    <article
      className={`character-detail character-detail--${character.id}`}
      style={{'--character-accent':character.accent}}
    >
      <motion.div
        className="character-detail__portrait"
        initial={{opacity:0,x:-45}}
        animate={{opacity:1,x:0}}
        transition={{duration:.8}}
      >
        <span className="character-detail__file">
          CHARACTER FILE · {character.number}
        </span>
        <b
          className="character-detail__watermark"
          aria-hidden="true"
        >
          {character.kanji}
        </b>
        <img
          src={character.image}
          alt={`${character.kanji} ${character.roman}`}
        />
        <blockquote>
          {english?character.quoteEn:character.quoteZh}
        </blockquote>
      </motion.div>

      <motion.div
        className="character-detail__content"
        initial={{opacity:0,y:35}}
        animate={{opacity:1,y:0}}
        transition={{duration:.8,delay:.12}}
      >
        <a
          className="character-detail__back"
          href={indexPath}
          onClick={(event)=>{
            event.preventDefault();
            onNavigate(indexPath);
          }}
        >
          ← {english?'ALL CHARACTERS':'返回人物名鑑'}
        </a>

        <header>
          <span>
            {english?character.bloodEn:character.bloodZh}
          </span>
          <h1>{character.kanji}</h1>
          <p>{character.roman}</p>
        </header>

        <dl>
          <div>
            <dt>{english?'TITLE':'稱號'}</dt>
            <dd>{english?character.roleEn:character.roleZh}</dd>
          </div>
          <div>
            <dt>{english?'DIVISION':'所屬'}</dt>
            <dd>
              {english?character.divisionEn:character.divisionZh}
            </dd>
          </div>
          <div>
            <dt>TEKUSE</dt>
            <dd>{character.tekuse}</dd>
          </div>
        </dl>

        <section>
          <span>{english?'CHARACTER PROFILE':'人物介紹'}</span>
          <p>
            {english?character.profileEn:character.profileZh}
          </p>
        </section>

        <section>
          <span>{english?'STORY':'人物故事'}</span>
          <p>{english?character.storyEn:character.storyZh}</p>
        </section>

        <section>
          <span>{english?'CORE TRAITS':'人物特質'}</span>
          <ol>
            {traits.map((trait,index)=>(
              <li key={trait}>
                <small>{String(index+1).padStart(2,'0')}</small>
                {trait}
              </li>
            ))}
          </ol>
        </section>

        <CharacterNavigation
          character={character}
          english={english}
          onNavigate={onNavigate}
        />
      </motion.div>
    </article>
  );
}

export default function CharactersPage({
  lang='zh-Hant',
  characterId='',
  onNavigate
}){
  const english=lang==='en';
  const character=characters.find(
    (item)=>item.id===characterId
  );

  if(character){
    return(
      <CharacterDetail
        character={character}
        english={english}
        onNavigate={onNavigate}
      />
    );
  }

  return(
    <CharacterIndex
      english={english}
      onNavigate={onNavigate}
    />
  );
}